import {ETextParamType_RoomID, ETextParamType_LocationHref} from './const';
import {hel_setText} from './moduleCaller';

/**
 * 検索バーのURLとRoomURLの置き換え
 */
export const hel_net_replace_room_url_with_roomid = (roomid: string | null) => {
  // 現在のURLのroomidパラメータを更新する
  const url = new URL(window.location.href);
  const search_params = url.searchParams;

  if (roomid === null) {
    search_params.delete('roomid');
  } else {
    search_params.set('roomid', roomid);
  }

  url.search = search_params.toString();

  // 新しいURLを発行して検索バーを置き換える
  const new_url = url.toString();
  window.history.pushState('', '', new_url);

  // エンジンのRoomURLとRoomIDを置き換え
  hel_setText(ETextParamType_RoomID, roomid ?? '');
  hel_setText(ETextParamType_LocationHref, new_url);
};
